import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cscCheckboxFilters = {
  contentGap: css`var(--csc-checkbox-filters-content-gap, ${csSpacing.spacing05})`,
  checkboxGap: css`var(--csc-checkbox-filters-checkbox-gap, var(--cse-checkbox-gap, ${csSpacing.spacing05}))`,
  showMoreDecorationLine: css`var(--csc-checkbox-filters-show-more-text-decoration-line, underline)`,
}

export const style: CSSResult = css`
  :host {
    --cse-accordion-default-header-background-color: transparent;
    --cse-icon-vertical-align: middle;
  }
  cse-expandable {
    --cse-expandable-list-row-gap: ${cscCheckboxFilters.contentGap};
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--csc-checkbox-filters-gap, ${csSpacing.spacing06});
  }

  .info-icon {
    --cse-icon-color: ${csColorFunctional.info};
  }

  .title-container{
    display: flex;
    align-items: center;
    gap : ${csSpacing.spacing04};
  }

  cse-swatch{
    --cse-color-swatch-outline-color: transparent;
  }
  .swatch-content {
    display: flex;
    align-items: center;
    gap: ${cscCheckboxFilters.checkboxGap};
  }

  .swatch-text {
    font-size: inherit;
  }

  .checkbox-item {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing05};
    line-height: .7;
  }
  .checkbox-item cse-tooltip {
    font-size: 14px;
  }

  csc-range-filter {
    width: 100%;
  }

  .filter-search {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    padding-block: ${csSpacing.spacing04} ${csSpacing.spacing06};
  }

  .filter-search cse-text-input {
    width: 100%;
  }

  .filter-search-feedback {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${csSpacing.spacing04};
  }

  cse-link {
    --cse-link-text-decoration-line: ${cscCheckboxFilters.showMoreDecorationLine};
  }
  `
